
<!--
这个页不需要了，在userLoginPC上集成了检测是不是手机的字段，在那里做了响应式布局，同时决定跳转到哪个applist页
-->

<template>
<div>
  <van-tabs v-model="active" :swipeable="true" :animated="true">
    <van-tab v-for="index in 1" :title="'选项 ' + index" :key="index" style="background-color: #DFDFDF;min-height: 300px">
      内容 {{ index }}
    </van-tab>
  </van-tabs>
</div>
</template>

<script>
export default {
name: "userLogInMobile",
  data(){
  return{
    active:""
  }
  },
  mounted() {

  },
  methods:{

  }
}
</script>

<style scoped>

</style>